/**
 * Multiple segments in a route can have the same param name. As a result,
 * `params` is of type `string | string[]`. This function returns either the
 * string or the first string, if passed an array.
 */
export const ensureString = (param: string | string[] | undefined): string => {
  if (typeof param === 'undefined') return undefined as any;
  if (typeof param === 'string') return param;
  return param?.[0];
};
